import { render, staticRenderFns } from "./fedex.vue?vue&type=template&id=a5dc1ba2"
import script from "./fedex.vue?vue&type=script&lang=js"
export * from "./fedex.vue?vue&type=script&lang=js"
import style0 from "./fedex.vue?vue&type=style&index=0&id=a5dc1ba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports